"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClipTemplateOverlays = exports.ClipTemplateOverlayTypes = exports.ClipTemplateAssets = void 0;
var ClipTemplateAssets;
(function (ClipTemplateAssets) {
    ClipTemplateAssets["Intro"] = "intro";
    ClipTemplateAssets["Overlay"] = "overlay";
    ClipTemplateAssets["Outro"] = "outro";
    ClipTemplateAssets["Audio"] = "audio";
})(ClipTemplateAssets = exports.ClipTemplateAssets || (exports.ClipTemplateAssets = {}));
var ClipTemplateOverlayTypes;
(function (ClipTemplateOverlayTypes) {
    ClipTemplateOverlayTypes["Graphic"] = "graphic";
    ClipTemplateOverlayTypes["Text"] = "text";
    ClipTemplateOverlayTypes["Video"] = "video";
})(ClipTemplateOverlayTypes = exports.ClipTemplateOverlayTypes || (exports.ClipTemplateOverlayTypes = {}));
var ClipTemplateOverlays;
(function (ClipTemplateOverlays) {
    ClipTemplateOverlays["IntroLogo"] = "intro-logo";
    ClipTemplateOverlays["IntroText"] = "intro-text";
    ClipTemplateOverlays["IntroMedia"] = "intro-media";
    ClipTemplateOverlays["OverlayImage"] = "clip-overlay";
    ClipTemplateOverlays["OverlayGraduateText"] = "clip-overlay-graduate";
    ClipTemplateOverlays["OverlaySubtitleText"] = "clip-overlay-subtitle";
    ClipTemplateOverlays["OverlaySecondSubtitleText"] = "clip-overlay-second-subtitle";
    ClipTemplateOverlays["OutroLogo"] = "outro-logo";
    ClipTemplateOverlays["OutroText"] = "outro-text";
    ClipTemplateOverlays["OutroMedia"] = "outro-media";
})(ClipTemplateOverlays = exports.ClipTemplateOverlays || (exports.ClipTemplateOverlays = {}));
//# sourceMappingURL=clip-template.js.map